import classNames from 'classnames';
import React from 'react';

import {Organization} from 'orgs/OrganizationConstants';

interface OrgElementProps {
  onOrganizationClick: (organization: Organization) => void;
  organization: Organization;
  selectedOrganizationId?: string;
}

const OrgElement = ({
  onOrganizationClick,
  organization,
  selectedOrganizationId,
}: OrgElementProps): JSX.Element => {
  function _handleClick(): void {
    onOrganizationClick(organization);
  }
  const isSelected = selectedOrganizationId === organization.id;

  return (
    <button
      onClick={_handleClick}
      className={classNames('button button--large orgList-org-element-button', {
        'orgList-org-element-button-selected': isSelected,
        'orgList-org-element-button-not-selected': !isSelected,
      })}
      type="button"
    >
      {organization.name}
    </button>
  );
};

interface OrgListProps {
  selectedOrganizationId?: string;
  organizations: Array<Organization>;
  onOrganizationSelected: (organization: Organization) => void;
}

const OrgList = (props: OrgListProps): JSX.Element => (
  <div className="orgList-container">
    {props.organizations.map((organization, i) => (
      <OrgElement
        key={organization.id}
        organization={organization}
        onOrganizationClick={props.onOrganizationSelected}
        selectedOrganizationId={props.selectedOrganizationId}
      />
    ))}
  </div>
);

export default OrgList;
